import React, { Component } from "react";
import { debounce } from "lodash";

import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
  Creators as UsersActions,
  Selectors as UsersSelectors,
} from "store/ducks/users";

import { Form } from "components";

class Filters extends Component {
  constructor(props) {
    super(props);

    const { getUsersGroupsRequest } = this.props;

    this.handleSearchGroups = debounce(getUsersGroupsRequest, 300);
  }

  componentDidMount() {
    const { getUsersGroupsRequest } = this.props;
    getUsersGroupsRequest();
  }

  handleFindGroups = (value) => {
    this.handleSearchGroups(value);
  };

  handleSelectGroups = (value) => {
    const { onChange } = this.props;

    onChange("group", value);
  };

  render() {
    const { data, groups, onChange, onClean, onSubmit } = this.props;

    return (
      <Form className="row form-filters">
        <Form.Field className="col-md-2 col-sm-4">
          <Form.Label>Nome do Usuário</Form.Label>
          <Form.Input
            value={data.name}
            onChange={(e) => onChange("name", e.target.value)}
          />
        </Form.Field>

        <Form.Field className="col-md-2 col-sm-4">
          <Form.Label>LDAP</Form.Label>
          <Form.Input
            value={data.ldap}
            onChange={(e) => onChange("ldap", e.target.value)}
          />
        </Form.Field>

        {!!groups.data.length && (
          <Form.Field className="col-md-2 col-sm-4">
            <Form.Label>Grupos</Form.Label>
            <Form.Select
              placeholder="Grupos"
              noOptionsMessage={() => "Procurar grupos"}
              options={groups.data}
              value={data.group}
              onChange={this.handleSelectGroups}
              onInputChange={this.handleFindGroups}
            />
          </Form.Field>
        )}

        <Form.Field className="col-md-3 col-sm-4">
          <Form.Button className="button-clean-filter" onClick={onClean}>
            Resetar Filtro
          </Form.Button>

          <Form.Button
            className="button-apply-filter"
            type="buton"
            onClick={onSubmit}
          >
            Aplicar Filtro
          </Form.Button>
        </Form.Field>
      </Form>
    );
  }
}

const mapState = (state) => ({
  groups: {
    ...state.users.groups,
    data: UsersSelectors.groups(state.users.groups.data),
  },
});

const mapActions = (dispatch) => bindActionCreators(UsersActions, dispatch);

export default connect(mapState, mapActions)(Filters);
